.tooltip-container {
  align-items: flex-end;
  cursor: help;
  display: flex;
  position: relative;
}

.tooltip_small,
.tooltip_medium,
.tooltip_large {
  background-color: var(--color-grey-700);
  border-radius: 0.5rem;
  color: var(--color-uva-white);
  font-weight: 400;
  padding: 0.5rem;
  position: fixed;
  text-align: center;
  transform: translate(-50%, -50%);
  white-space: normal;
  z-index: 10;
}

.tooltip_small {
  height: 4rem;
  width: 14.5rem;
}

.tooltip_medium {
  height: 5.5rem;
  width: 20rem;
}

.tooltip_large {
  height: 5.5rem;
  width: 24.5rem;
}

.tooltip_small::before,
.tooltip_medium::before,
.tooltip_large::before {
  border: 0.5rem solid transparent;
  border-top-color: var(--color-grey-700);
  content: "";
  height: 0;
  position: absolute;
  width: 0;
}

.tooltip_small::before {
  right: 1rem;
  top: 4rem;
}

.tooltip_medium::before {
  right: 3rem;
  top: 5.5rem;
}

.tooltip_large::before {
  right: 4rem;
  top: 5.5rem;
}

.tooltip_under-trigger {
  background-color: var(--color-grey-700);
  border-radius: 0.5rem;
  color: var(--color-uva-white);
  font-weight: 400;
  max-width: calc(100vw - 2rem);
  padding: 0.25rem 1rem;
  position: fixed;
  right: 1rem;
  top: 3.5rem;
}

.tooltip_under-trigger::before {
  border-bottom: 0.5rem solid var(--color-grey-700);
  border-left: 0.5rem solid transparent;
  border-right: 0.5rem solid transparent;
  content: "";
  height: 0;
  position: absolute;
  right: 3.5rem;
  top: -0.5rem;
  width: 0;
}

@media (min-width: 50rem) {
  .tooltip_under-trigger {
    right: 0.5rem;
  }
}
